import i18n from 'modules/core/lib/i18n'

import { TaskDefinition } from 'modules/inbox_tasks/lib/abstraction'

import VendorOnboardingTaskContent from './VendorOnboardingTaskContent'

export const VendorOnboardingTaskDefinition: TaskDefinition<'ProcurementVendorOnboardingTask'> = {
  taskableTypename: 'ProcurementVendorOnboardingTask',
  initialState: {},
  component: VendorOnboardingTaskContent,
  getTitle: ({ info }) =>
    i18n.t('tasks.types.vendor_onboarding.title', {
      taskName: info.purchaseRequest?.description ?? '',
    }),
  getMetadata: ({ info }) => [info.purchaseRequest?.description || ''],
}
